export const elementID = 'instant-games_read-calculate-CSS-var';

const getBufferElement = () => {
  let element = document.getElementById(elementID);

  if (!element) {
    element = setupBufferElement();
  }

  return element;
};

const setupBufferElement = () => {
  const element = document.createElement('div');
  element.setAttribute('id', elementID);
  // detach it from the flow so it doesn't break anything
  element.setAttribute('position', 'absolute');
  element.setAttribute('z-index', '-1');
  element.setAttribute('visibility', 'hidden');
  // won't work unless you actually append it to the DOM
  document.body.appendChild(element);

  return element;
};

export const readCSSVar = (element, varName) => {
  if (!element) {
    console.error(`Can't find the node`, element);
    return;
  }

  const buffer = getBufferElement();

  buffer.style.strokeWidth = window
    .getComputedStyle(element)
    .getPropertyValue(varName);

  return getComputedStyle(buffer).getPropertyValue('stroke-width');
};
